<div class="container">
    <mat-card>
        <mat-card-title class="cabecalho-login">
            <img class="logo" src="../../../assets/toobook-logo.png" alt="Logo Toobook" />
        </mat-card-title>

        <mat-card-content>
            <form [formGroup]="form">
                <mat-form-field appearance="outline">
                    <mat-label>E-mail</mat-label>
                    <input matInput formControlName="email" />
                    <mat-error *ngIf="isInvalid('email')">{{ errorMessage("email") }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Senha</mat-label>
                    <input matInput type="password" formControlName="senha" (keyup.enter)="fazerLogin()" />
                    <mat-error *ngIf="isInvalid('senha')">{{ errorMessage("senha") }}
                    </mat-error>
                </mat-form-field>
            </form>

            <div>
                <button mat-raised-button color="primary" (click)="fazerLogin()">
          Entrar
        </button>
            </div>
        </mat-card-content>
    </mat-card>
</div>